import type { CustomerCardFormValues } from '@makemydeal/dr-dash-types';
import { CustomerAddressProvider } from './CustomerAddressProvider';
import type { CustomerAddressProps } from './CustomerAddresses';
import { CustomerAddresses } from './CustomerAddresses';
import type { AddressType } from './CustomerAddressTypes';
import type { ContractFlowValidationEngine } from '../../hooks/useFormValidationWithContractFlow';

type CustomerAddressesInterstate = CustomerAddressProps & {
    initialFormValues: CustomerCardFormValues;
    validator: ContractFlowValidationEngine;
    onAddressFieldChange?: (addressType: AddressType, field: string, value: string) => void;
    disabled?: boolean;
};
export const CustomerAddressesInterstate = ({
    initialFormValues,
    validator,
    onAddressFieldChange,
    disabled,
    ...props
}: CustomerAddressesInterstate) => {
    return (
        <CustomerAddressProvider
            initialFormValues={initialFormValues}
            validator={validator}
            onAddressFieldChange={onAddressFieldChange}
            disabled={disabled}
        >
            <CustomerAddresses {...props} disabled={disabled} />
        </CustomerAddressProvider>
    );
};
